import { render, staticRenderFns } from "./Getcoach.vue?vue&type=template&id=3c67dab8&scoped=true"
import script from "./Getcoach.vue?vue&type=script&lang=js"
export * from "./Getcoach.vue?vue&type=script&lang=js"
import style0 from "./Getcoach.vue?vue&type=style&index=0&id=3c67dab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c67dab8",
  null
  
)

export default component.exports